import { useState, useContext } from "react"
import { CustomButton } from "../../components/global/CustomButton"
import { ProductRow } from "../components/products/ProductRow"
import { Link } from "react-router-dom"
import { ProductsContext } from "../../contexts/ProductsContext"
import "./adminProducts.css"

export function AdminProducts() {
    const categories = ["Men's clothing", "Women's clothing", "Jewlery", "Electronics"]

    const [category, setCategory] = useState(categories[0].toLowerCase())
    const [activeCategory, setActiveCategory] = useState(null)

    const productsDataContext = useContext(ProductsContext)
    const { products } = productsDataContext
    
    return (
        <div className="admin-products">
            <h4>Products</h4>

            <div className="d-flex mt-5 products-actions md-row">
                <div className="d-flex gap-2">
                    <div className="custom-btn default rounded-1 d-flex cntr gap-3">
                        <div className="export-icon"></div>
                        <div>Export</div>
                    </div>
                    <div className="custom-btn default rounded-1 d-flex cntr gap-3">
                        <div className="import-icon"></div>
                        <div>Import</div>
                    </div>
                </div>
                
                <Link to="/admin/products/add" className="custom-btn secondary rounded-1 d-flex cntr gap-3 ms-auto">
                    <div className="plus-icon"></div>
                    <div>Add Product</div>
                </Link>
            </div>

            <div className="d-flex justify-content-end gap-2 category-filter md-row">
                <div><span className="me-2">Category:</span>
                    <select
                        id="category"
                        className="ms-2 rounded-1"
                        value={category}
                        onChange={(e) => setCategory(e.target.value)}>
                            {
                                categories.map((e, i) => (
                                    <option key={i} value={e.toLowerCase()}>{e}</option>
                                ))
                            }
                    </select>
                </div>
                <div className="d-flex gap-2">
                    <CustomButton
                        color="primary"
                        text="Filter"
                        btnFunction={() => setActiveCategory(category)}
                    />
                    <CustomButton
                        color="default"
                        text="Reset"
                        btnFunction={() => setActiveCategory(null)}
                    />
                </div>
            </div>

            <div className="border rounded-1 mt-2">
                <div className="table-wrapper">
                    <table className="products-table mt-1 mb-3">
                        <tbody>
                            <tr className="table-header">
                                <td>Name</td>
                                <td>Category</td>
                                <td>Price</td>
                                <td>Sale Price</td>
                                <td>Stock</td>
                                <td className="text-end pe-4">Action</td>
                            </tr>
                        </tbody>
                    </table>

                    {
                        activeCategory === null ?
                            products && products.map((e, i) => (
                                <ProductRow
                                    key={i}
                                    product={e}
                                />
                            ))
                            :
                            products && products.filter(a => a.category === activeCategory).map((e, i) => (
                                <ProductRow
                                    key={i}
                                    product={e}
                                />
                            ))
                    }
                </div>
                
            </div>
        </div>
    )
}